const rankings = [
  { rank: 1, title: '庆余年 第二季', type: '电视剧', heat: '本周最热', tag: '热播', icon: 'ri-fire-line', color: 'text-primary-500' },
  { rank: 2, title: '热辣滚烫', type: '电影', heat: '口碑佳作', tag: '高分', icon: 'ri-star-line', color: 'text-accent-500' },
  { rank: 3, title: '奔跑吧 第八季', type: '综艺', heat: '话题飙升', tag: '热综', icon: 'ri-bar-chart-line', color: 'text-accent-600' },
  { rank: 4, title: '三体', type: '电视剧', heat: '科幻神作', tag: '经典', icon: 'ri-rocket-line', color: 'text-secondary-600' },
  { rank: 5, title: '飞驰人生2', type: '电影', heat: '票房冠军', tag: '高分', icon: 'ri-medal-line', color: 'text-accent-500' },
  { rank: 6, title: '间谍过家家 第二季', type: '动漫', heat: '人气番剧', tag: '热追', icon: 'ri-heart-line', color: 'text-primary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">热播榜单</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">看看大家都在追什么，热门影视一站掌握</p>
        <div className="space-y-3">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#carousel"
              className="flex items-center gap-4 bg-background-100 border border-background-200/70 rounded-lg p-4 hover:border-accent-300 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-full font-heading font-bold text-lg ${item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-foreground-900 text-sm md:text-base group-hover:text-primary-600 transition-colors">{item.title}</span>
                  <span className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">{item.type}</span>
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex items-center gap-1.5 text-xs text-foreground-600 whitespace-nowrap">
                <i className={`${item.icon} ${item.color} text-sm`}></i>
                {item.heat}
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-8">
          <a href="#index" className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}